"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ramda_1 = require("ramda");
const scalars_1 = require("../scalars");
exports.default = (schemaComposer) => {
    ramda_1.keys(scalars_1.VLContentScalars).forEach(scalar => {
        schemaComposer.createScalarTC(`scalar ${scalar}`);
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWRkVkxTY2FsYXJzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2Ntcy9zY2hlbWEvYnVpbGRlcnMvYWRkVkxTY2FsYXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQ0EsaUNBQTZCO0FBQzdCLHdDQUE4QztBQUU5QyxrQkFBZSxDQUFDLGNBQW1DLEVBQUUsRUFBRTtJQUNyRCxZQUFJLENBQUMsMEJBQWdCLENBQUMsQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLEVBQUU7UUFDdEMsY0FBYyxDQUFDLGNBQWMsQ0FBQyxVQUFVLE1BQU0sRUFBRSxDQUFDLENBQUM7SUFDcEQsQ0FBQyxDQUFDLENBQUM7QUFDTCxDQUFDLENBQUMifQ==